import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCurrentSession } from "../../services/auth";
import ProductPriceManager from "./ProductPriceManager";
import ProductAssociationManager from "./ProductAssociationManager";
import MembershipProductInclusionManager from "./MembershipProductInclusionManager";

const API_URL = (
  process.env.REACT_APP_API_URL || "https://zedro-backend.onrender.com"
).replace(/\/$/, "");

export default function ProductDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    async function loadProduct() {
      try {
        setLoading(true);

        const session = getCurrentSession();
        const token = session?.token;

        const res = await fetch(`${API_URL}/api/admin/products/${id}/full`, {
          headers: token
            ? {
                Authorization: `Bearer ${token}`,
              }
            : {},
        });

        const json = await res.json().catch(() => ({}));

        if (!res.ok) {
          throw new Error(json?.error || "cannot_load_product");
        }

        if (alive) {
          setData(json);
        }
      } catch (err) {
        console.error("[ADMIN] cannot_load_product", err);

        if (alive) {
          setData({ ok: false });
        }
      } finally {
        if (alive) {
          setLoading(false);
        }
      }
    }

    loadProduct();

    return () => {
      alive = false;
    };
  }, [id]);

  if (loading) return <div>Cargando producto...</div>;
  if (!data?.ok) return <div>Error cargando producto</div>;

  const { product, prices } = data;

  return (
    <main
      style={{
        maxWidth: 1000,
        margin: "2rem auto",
        fontFamily: "Questrial, sans-serif",
      }}
    >
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "1rem",
          marginBottom: "1.5rem",
          flexWrap: "wrap",
        }}
      >
        <div>
          <div style={{ marginBottom: 10 }}>
            <a
              href="/admin/productos"
              style={{
                textDecoration: "none",
                color: "#264763",
                fontWeight: 700,
                fontSize: "0.9rem",
              }}
            >
              ← Volver a Productos
            </a>
          </div>

          <h1
            style={{
              margin: 0,
              fontFamily: "Bitter, serif",
              fontSize: 28,
              color: "#0a2230",
              fontWeight: 800,
            }}
          >
            {product.name}
          </h1>

          <div style={{ marginTop: 10, display: "flex", gap: 8, flexWrap: "wrap" }}>
            <span
              style={{
                border: "1px solid #e6ebf1",
                background: "#fafafa",
                padding: "6px 10px",
                borderRadius: 999,
                color: "#2c3b51",
                fontSize: "0.8rem",
                fontWeight: 700,
                textTransform: "uppercase",
              }}
            >
              {product.product_type}
            </span>

            <span
              style={{
                border: "1px solid #e6ebf1",
                background: "#fff",
                padding: "6px 10px",
                borderRadius: 999,
                color: "#6b7a88",
                fontSize: "0.8rem",
                fontWeight: 700,
                textTransform: "uppercase",
              }}
            >
              {product.status}
            </span>

            <span
              style={{
                border: "1px solid #e6ebf1",
                background: product.is_active ? "#e8f5e9" : "#fff",
                padding: "6px 10px",
                borderRadius: 999,
                color: product.is_active ? "#2e7d32" : "#6b7a88",
                fontSize: "0.8rem",
                fontWeight: 700,
                textTransform: "uppercase",
              }}
            >
              {product.is_active ? "Activo" : "Inactivo"}
            </span>
          </div>

          <p
            style={{
              margin: "0.35rem 0 0",
              color: "#6b7a88",
              fontSize: "0.95rem",
            }}
          >
            {product.description || "Sin descripción"}
          </p>
        </div>
      </header>

      <section
        style={{
          border: "1px solid #e6ebf1",
          borderRadius: 14,
          padding: 16,
          background: "#fff",
          boxShadow: "0 10px 30px rgba(0,0,0,.05)",
          marginBottom: 20,
        }}
      >
        <h3 style={{ marginTop: 0 }}>Información</h3>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div><strong>Tipo:</strong> {product.product_type}</div>
          <div><strong>Status:</strong> {product.status}</div>
          <div><strong>Activo:</strong> {product.is_active ? "Sí" : "No"}</div>
          <div><strong>Stripe ID:</strong> {product.stripe_product_id || "—"}</div>
        </div>
      </section>

      <ProductPriceManager
        key={`prices-${product.id}`}
        productId={product.id}
        initialPrices={prices}
      />

      {product.product_type === "membership" ? (
        <MembershipProductInclusionManager
          key={`membership-products-${product.id}`}
          productId={product.id}
        />
      ) : (
        <ProductAssociationManager
          key={`product-composition-${product.id}`}
          productId={product.id}
        />
      )}
    </main>
  );
}
